var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 20H20.5V5C20.5 4.73478 20.3946 4.48043 20.2071 4.29289C20.0196 4.10536 19.7652 4 19.5 4C19.2348 4 18.9804 4.10536 18.7929 4.29289C18.6054 4.48043 18.5 4.73478 18.5 5V20H16.5V13C16.5 12.7348 16.3946 12.4804 16.2071 12.2929C16.0196 12.1054 15.7652 12 15.5 12C15.2348 12 14.9804 12.1054 14.7929 12.2929C14.6054 12.4804 14.5 12.7348 14.5 13V20H12.5V9C12.5 8.73478 12.3946 8.48043 12.2071 8.29289C12.0196 8.10536 11.7652 8 11.5 8C11.2348 8 10.9804 8.10536 10.7929 8.29289C10.6054 8.48043 10.5 8.73478 10.5 9V20H8.5V17C8.5 16.7348 8.39464 16.4804 8.20711 16.2929C8.01957 16.1054 7.76522 16 7.5 16C7.23478 16 6.98043 16.1054 6.79289 16.2929C6.60536 16.4804 6.5 16.7348 6.5 17V20H4.5V3C4.5 2.73478 4.39464 2.48043 4.20711 2.29289C4.01957 2.10536 3.76522 2 3.5 2C3.23478 2 2.98043 2.10536 2.79289 2.29289C2.60536 2.48043 2.5 2.73478 2.5 3V21C2.5 21.2652 2.60536 21.5196 2.79289 21.7071C2.98043 21.8946 3.23478 22 3.5 22H21.5C21.7652 22 22.0196 21.8946 22.2071 21.7071C22.3946 21.5196 22.5 21.2652 22.5 21C22.5 20.7348 22.3946 20.4804 22.2071 20.2929C22.0196 20.1054 21.7652 20 21.5 20Z",
    fill: "#8F99D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/chart_bar.d3b17680.svg";
export { ForwardRef as ReactComponent };